import React from 'react';
import { Icon } from 'ui';
import RatingScale from 'ui/RatingScale';

export default class Criterion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { score: props.criterion.score, comment: '' };
    this.setScore = this.setScore.bind(this);
  }

  setScore(score) {
    if (this.props.onChange) {
      this.setState({ score });
      this.props.onChange(
        this.props.answerId,
        this.props.criterion.id,
        score,
        this.state.comment,
      );
    }
  }

  handleInputChange = e => {
    let { value } = e.target;
    value = value.replace(/\r?\n|\r/g, ' ');
    this.setState({ comment: value });

    if (this.props.onChange) {
      this.props.onChange(
        this.props.answerId,
        this.props.criterion.id,
        this.state.score,
        value,
      );
    }
  };

  render() {
    const {
      criterion,
      ratingOptions,
      showComments,
      hoverCount,
      setHoverCount,
    } = this.props;
    const { comment } = this.state;
    return (
      <div className="mb-32">
        <div className="CriteriaList-criterion mb-8">
          {criterion.name}
          <span
            className="ml-4 h-c-night"
            data-toggle="tooltip"
            title={
              criterion.description ||
              t('feedback_criteria.criterion.no_description')
            }
            data-placement="top"
          >
            <Icon name="info" />
          </span>
        </div>
        <div className="d-f fd-c">
          <RatingScale
            ratingOptions={ratingOptions}
            score={this.state.score}
            setScore={this.setScore}
            setHoverCount={setHoverCount}
            hoverCount={hoverCount}
            customClassName="mb-16 d-f fw-w"
          />
          {showComments && (
            <textarea
              className="Textarea bg-white p-8 bdrs-2 h-70"
              placeholder={t('demonstrations.progress.feedback_placeholder')}
              onChange={this.handleInputChange}
              value={comment || ''}
            />
          )}
        </div>
      </div>
    );
  }
}
